import cloneDeep from 'lodash/cloneDeep';
import { NEW_FILTER_ID } from '@/utils/filter';
import { validateFilterQuery } from '../../../../../types/query';
/**
 * Type guard to check if the filter is a valid node filter
 * TODO: CDM-1147 - Replace common validateFilterQuery with separate validator function based on query schema
 */
export function isNodeQueryValid(filter) {
    return validateFilterQuery(filter.queryObject);
}
/**
 * Check if node filter is an ad hoc filter
 */
export function isNodeFilterNew(filter) {
    return filter.id === NEW_FILTER_ID;
}
/**
 * Check if node filters match
 */
export function checkNodeFiltersMatch(filterA, filterB) {
    return filterA.id === filterB.id;
}
/**
 * Evaluate if the selected filter is applied
 */
export function checkSelectedFilterApplied(selectedFilter, filter) {
    return !!selectedFilter && !!filter && checkNodeFiltersMatch(selectedFilter, filter) && !isNodeFilterNew(filter);
}
/**
 * Evaluate if user can apply the selected filter
 */
export function canApplySelectedFilter(selectedFilter, filter) {
    // User cannot apply an empty filter if is no applied filter
    if (!selectedFilter && !filter)
        return false;
    // User cannot apply selected filter if it matches the applied filter
    if (checkSelectedFilterApplied(selectedFilter, filter))
        return false;
    // User cannot apply selected filter if it is not valid
    if (!!selectedFilter && !isNodeQueryValid(selectedFilter))
        return false;
    // All other cases, the user can apply the filter
    return true;
}
/**
 * Parse and validate the json search params from the URL
 */
export function parseNodeFilterSearchParam(jsonString) {
    if (jsonString === null)
        return null;
    try {
        var filter = JSON.parse(jsonString);
        // Light validation to ensure the filter is a valid node filter
        if (!filter || typeof filter !== 'object' || !('queryObject' in filter) || !validateFilterQuery(filter.queryObject))
            return null;
        return filter;
    }
    catch (err) {
        /* istanbul ignore next */
        return null;
    }
}
/**
 * Format node filter for search params
 */
export function formatNodeFilterSearchParam(filter) {
    try {
        return JSON.stringify(filter);
    }
    catch (err) {
        /* istanbul ignore next */
        return '';
    }
}
/**
 * Verify node filter from smartgroups
 * This is to prevent the filter from being out of "sync" if the filter is deleted or changed.
 */
export function verifyNodeFilter(filter, smartgroups) {
    // Leave filter as is, when filter is new or smartgroups are undefined
    if (!filter || isNodeFilterNew(filter) || !smartgroups)
        return filter;
    var foundFilter = smartgroups.find(function (smartgroup) { return checkNodeFiltersMatch(filter, smartgroup); });
    return !foundFilter || !isNodeQueryValid(foundFilter) ? null : foundFilter;
}
/**
 * Verify selected node filter from smartgroups
 * This is to prevent the filter from being out of "sync" if the filter is deleted or changed.
 */
export function verifySelectedNodeFilter(filter, smartgroups) {
    var _a;
    // Leave filter as is, when filter is new or smartgroups are undefined
    if (!filter || isNodeFilterNew(filter) || !smartgroups)
        return filter;
    return (_a = smartgroups.find(function (smartgroup) { return checkNodeFiltersMatch(filter, smartgroup); })) !== null && _a !== void 0 ? _a : null;
}
/**
 * Applies prefix to each item in a filter query
 * Mutates the query object passed into the function
 */
export function applyPrefixToQueryObject(prefix, queryObject) {
    if (!prefix || !queryObject)
        return undefined;
    var prefixQueryObject = cloneDeep(queryObject);
    prefixQueryObject.items[0].items.forEach(function (_a, querySetIndex) {
        var queryItems = _a.items;
        queryItems.forEach(function (_a, queryIndex) {
            var fieldname = _a.fieldname;
            prefixQueryObject.items[0].items[querySetIndex].items[queryIndex].fieldname = "".concat(prefix, ":").concat(fieldname);
        });
    });
    return prefixQueryObject;
}
